<template>
    <div>
        
        <!-- Notifications -->

        <trax-ui-ajax-data-table 
            :id="id+'-table'" :props="props" :endpoint="endpoint" :endpoint-params="endpointParams"
            :header="header" :paging="paging" :searching="searching" :bus="bus"
            :empty-message="lang.polaris.notification.no_notification"
            :selectable="true" v-model="selection"
            ref="notifications"
        >
            <div class="ml-2 mt-3">
                <button type="button" class="btn btn-danger btn-sm mr-2" @click="deleteAll"> {{ lang.polaris.form.delete_all }} </button>
                <button v-if="selection.length" type="button" class="btn btn-danger btn-sm" @click="deleteSelection"> {{ lang.polaris.form.delete_selection }} </button>
                <button v-if="orpheansCount" type="button" class="btn btn-danger btn-sm" @click="deleteOrpheans"> {{ lang.polaris.form.delete_orpheans }} ({{ orpheansCount }}) </button>
            </div>
        </trax-ui-ajax-data-table>
        
        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="this.lang.polaris.notification.delete_notifications" :bus="bus">
            {{ lang.polaris.notification.delete_notifications_confirm }}
        </trax-ui-modal-confirm>

    </div>

</template>

<script>
    export default {
    
        props: {
            id: { default: 'trax-notification-procedure' },
            header: { default: 0 },
            paging: { default: 1 },
            searching: { default: 1 },
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                endpoint: app_url+"polaris/api/front/procedure-notifications",
                endpointParams: {
                    sort: ['-id'],
                },
                props: [
                    {source: this.preview, orderable: false },
                ],
                procedures: {},
                selection: [],
                deleteParams: {},
                orpheansCount: 0,
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-notification-deleted', this.deleted);
            this.bus.$on(this.id+'-notification-read', this.read);
            this.bus.$on(this.id+'-delete-confirmed', this.deleteNow);

            this.loadOrpheansCount();
        },

        mounted: function() {
            var that = this;

            $('#'+this.id+'-table-table tbody').on( 'click', '.notification-link', function(event) {
                that.open($(this).attr('data-id'));
            });

        },

        methods: {

            deleteAll() {
                this.deleteParams = {}
                this.bus.$emit(this.id+'-delete-open');
            },
        
            deleteSelection() {
                this.deleteParams = {params: {ids: this.selection}}
                this.bus.$emit(this.id+'-delete-open');
            },
        
            deleteNow() {
                axios.delete(
                    this.app_url+"polaris/api/front/my-procedure-notifications",
                    this.deleteParams
                )
                .then(response => {
                    this.$refs.notifications.refresh();
                })
                .catch(error => {
                });
            },
        
            loadOrpheansCount() {
                axios.get(
                    this.app_url+"polaris/api/front/orphean-notifications",
                )
                .then(response => {
                    this.orpheansCount = response.data.count;
                })
                .catch(error => {
                });
            },
        
            deleteOrpheans() {
                axios.delete(
                    this.app_url+"polaris/api/front/orphean-notifications",
                )
                .then(response => {
                    this.orpheansCount = 0;
                })
                .catch(error => {
                });
            },

            preview(data, type, row, meta) {
                this.procedures[row.id] = row;
                var title = row.id
                    ? '[' + row.notifications[0].data.context.procedure.type.toUpperCase() + '] ' + row.name
                    : row.name;
                var res = '';
                if (row.unread_notifications > 0) {
                    res += '<span class="badge badge-danger float-right ml-1" style="padding:5px 7px">' + Object.keys(row.notifications).length + '</span>';
                } else {
                    res += '<span class="badge badge-light text-secondary float-right ml-1" style="padding:5px 7px">' + Object.keys(row.notifications).length + '</span>';
                }
                res += '<span class="font-weight-bold">'+title+'<span>';
                if (row.id) {
                    if (row.user_id) {
                        res += '<br><span class="font-weight-light">' + row.notifications[0].data.context.user.name + ' (' + row.notifications[0].data.context.cohort.name + ')</span>';
                    } else {
                        res += '<br><span class="font-weight-light">' + row.notifications[0].data.context.cohort.name + '</span>';
                    }
                }
                res += '<br><small class="font-weight-light">'+moment(row.notifications[0].created_at).format('DD MMM YYYY')+'</small>';
                return '<div class="notification-link" style="cursor:pointer" data-id="'+row.id+'">'+res+'</div>';
            },

            open(id) {
                var procedure = this.procedures[id];
                this.bus.$emit(this.id+'-modal-open', { headerColor: 'danger', icon: 'notifications', title: procedure.name, data: procedure });
            },

            deleted(id) {
                this.bus.$emit(this.id+'-table-refresh', id);
            },

            read(id) {
                $('#'+this.id+'-table-table tbody .notification-link[data-id='+id+'] .badge.badge-danger').removeClass('badge-danger').addClass('badge-light text-secondary');
            }
        }
    }
</script>
